export enum enumSasTimeToSendEmail {
  'N/A' = 0,
  'Office Hours' = 1,
  'After Hours' = 2,
}

export namespace enumSasTimeToSendEmail {
  export function values() {
    return Object.keys(enumSasTimeToSendEmail).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}